import { call, put, takeLatest } from 'redux-saga/effects';
import { Map } from 'immutable';
import { Notification } from '@utils';
import { delExclusaoDados as delExclusaoDadosSdk } from '@sdk/Indicadores/ExclusaoDados';

//Action Types
export const Types = {
  DELETE_EXCLUSAO_DADOS: 'DELETE_EXCLUSAO_DADOS',
  DELETE_EXCLUSAO_DADOS_SUCCESS: 'DELETE_EXCLUSAO_DADOS_SUCCESS',
  DELETE_EXCLUSAO_DADOS_ERROR: 'DELETE_EXCLUSAO_DADOS_ERROR',

  RESET_EXCLUSAO_DADOS: 'RESET_EXCLUSAO_DADOS',
};

//Action Creators

export const deleteExclusaoDados = (data) => ({ type: Types.DELETE_EXCLUSAO_DADOS, data });
export const deleteExclusaoDadosSuccess = () => ({ type: Types.DELETE_EXCLUSAO_DADOS_SUCCESS });
export const deleteExclusaoDadosError = (error) => ({ type: Types.DELETE_EXCLUSAO_DADOS_ERROR, error });

export const reset = () => ({ type: Types.RESET_EXCLUSAO_DADOS });

//saga
function* fetchDeleteExclusaoDados(action) {
  try {
    const { data } = action;
    yield call(delExclusaoDadosSdk, data);
    yield put(deleteExclusaoDadosSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(deleteExclusaoDadosError(err));
  }
}

export const saga = [takeLatest(Types.DELETE_EXCLUSAO_DADOS, fetchDeleteExclusaoDados)];

// Reducer
const initialState = Map({
  deletingDados: false,
  successDeleteDados: false,
  errorDeleteDados: false,
});

const handleDeleteExclusaoDados = (state, action) => {
  return state.set('deletingDados', true).set('successDeleteDados', false).set('errorDeleteDados', false);
};

const handleDeleteExclusaoDadosSuccess = (state, action) => {
  return state.set('deletingDados', false).set('successDeleteDados', true).set('errorDeleteDados', false);
};

const handleDeleteExclusaoDadosError = (state, action) => {
  return state.set('deletingDados', false).set('successDeleteDados', false).set('errorDeleteDados', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.DELETE_EXCLUSAO_DADOS:
      return handleDeleteExclusaoDados(state, action);
    case Types.DELETE_EXCLUSAO_DADOS_SUCCESS:
      return handleDeleteExclusaoDadosSuccess(state, action);
    case Types.DELETE_EXCLUSAO_DADOS_ERROR:
      return handleDeleteExclusaoDadosError(state, action);

    case Types.RESET_EXCLUSAO_DADOS:
      return handleReset(state, action);

    default:
      return state;
  }
}
